import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchLocationMap,
  updateLocationMap,
} from "../../../slices/LocationSlice/locationMapSlice";

import Pagination from "../../../components/Pagination";
import EditableTable from "./LocationMapTable";
import Modal from "../../../components/Modal";
import ChangeLog from "../../../components/ChangeLog";
import AddLocationMap from "./AddLocationMap";
import { fetchCountryList } from "../../../slices/LocationSlice/countrySlice";
import Loader from "../../../components/Loader"
import { fetchSubCategoryList } from "../../../slices/LocationSlice/subCategorySlice";



function LocationMap({editable}) {
  const dispatch = useDispatch();
  const { locationMapList, status, error } = useSelector((state) => state.locationMap);
  const countryListData = useSelector((state) => state.countryList);
  const subCategory =useSelector((state) => state.subCategory);
  const [currentPage, setCurrentPage] = useState(1);
  const [editRowId, setEditRowId] = useState(null);
  const [editedData, setEditedData] = useState({});

  const itemsPerPage = 10;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = Array.isArray(locationMapList?.result)
    ? locationMapList?.result?.slice(indexOfFirstItem, indexOfLastItem)
    : [];
  const totalPages = Array.isArray(locationMapList?.result)
    ? Math.ceil(locationMapList?.result?.length / itemsPerPage)
    : 0;
  const headers =
  locationMapList?.result?.length > 0
      ? Object.keys(locationMapList.result[0]).filter((key) => key !== "id")
      : [];
  const editableFields = ["title","variableName","country"]; // Define editable fields

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentLog, setCurrentLog] = useState([]);
  const [addCountryModal, setAddCountryModal] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);




  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchLocationMap());
    }

    if(countryListData.status === "idle"){
      dispatch(fetchCountryList())
    }

    if(subCategory.status === "idle"){
      dispatch(fetchSubCategoryList())
    }
  }, [dispatch]);

  // if (status === "loading") {
  //   return <Loader></Loader>;
  // }

  const handleEdit = (rowId) => {
    setEditRowId(rowId);
    const rowData = locationMapList.result.find((user) => user.id === rowId);
    setEditedData(rowData);
  };

  const handleSave = async () => {
    const { id, title, variableName, country } = editedData;
    console.log(country);
    const countryId = countryListData.countryList.result.filter(f=>f.title===country)[0].id

    const finalData = {
      id,title,variableName,country:countryId
    }
    const resp = await dispatch(updateLocationMap(finalData));
    if (!resp.error) {
      setEditRowId(null);
      dispatch(fetchLocationMap());
    }
  };

  const handleCancel = () => {
    setEditRowId(null);
    setEditedData({});
  };

  const handleChange = (e, field, val) => {
    if (["status", "active"].includes(field)) {
      setEditedData((prev) => ({
        ...prev,
        [field]: !val,
      }));
    } else {
      setEditedData((prev) => ({
        ...prev,
        [field]: e.target.value,
      }));
    }
  };

  const handleLog = (id) => {
    const logData = locationMapList.Change_Log.filter((f) => f.id === id)[0]
      ?.oldTrack;
    setCurrentLog(logData);
    openModal();
  };



  return (
    <div className="w-full flex items-center flex-col">


      {status==='loading'?<>
        <Loader></Loader>
      </>:

      <div className="max-w-full">
 <EditableTable
       headers={headers}
       rows={currentItems}
       editRowId={editRowId}
       editedData={editedData}
       handleEdit={handleEdit}
       handleSave={handleSave}
       handleCancel={handleCancel}
       handleChange={handleChange}
       handleLog={handleLog}
       editableFields={editableFields} // Pass editable fields
       countryList={countryListData?.countryList}
       editable={editable}
     />
      </div>
      
      }
     


      <div className="flex mt-4 items-center justify-between w-11/12">
      <Pagination
  currentPage={currentPage}
  setCurrentPage={setCurrentPage}
  totalPages={totalPages}
/>
      {editable &&  <button
          className="activeBtn text-sm text-white  py-1 px-2 rounded"
          onClick={() => setAddCountryModal(true)}
        >
          + Add Location Map
        </button>}
       
      </div>

      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        title="Change Log"
        content={<ChangeLog data={currentLog} />}
      />

      <Modal
        isOpen={addCountryModal}
        onClose={() => setAddCountryModal(false)}
        title="Add Location Map"
        content={
          <AddLocationMap countryList={countryListData?.countryList} subCategoryList={subCategory.subCategoryList} />
        }
      />
    </div>
  );
}

export default LocationMap;
